import React from 'react'
import { Link } from 'react-router-dom'
import {
  IonImg
} from '@ionic/react'
import ContentButton from '../../core/player-parts/ContentButton'
import './styles.scss'

const PlayableChapterSmallCard = (props) => {
  const { chapter } = props

  if (chapter) {
    return (
      <div className='playable-chapter-small-card' itemScope itemType='http://schema.org/Episode'>

        <meta itemProp='url' content={`https://yokradio.com/ver/${chapter.id || chapter.id_content}_${chapter.url_title}`} />

        <section itemProp='publisher' itemScope itemType='http://schema.org/Organization'>
          <meta itemProp='url' content='https://yokradio.com/' />
          <meta itemProp='name' content='Yok Radio' />
          <div itemProp='logo' itemScope itemType='http://schema.org/ImageObject'>
            <meta itemProp='url' content='https://yokradio.com/assets/icon/android-chrome-1024x1024.png' />
          </div>
        </section>

        <figure itemProp='image' itemScope itemType='http://schema.org/ImageObject'>
          <meta itemProp='contentUrl' content={chapter.photo_min} />
          <Link
            to={`/ver/${chapter.id || chapter.id_content}_${chapter.url_title}`}
            aria-label={`Ver ${chapter.title}`}
          >
            {chapter.photo_min &&
              <IonImg
                alt={`Portada del episodio ${chapter.title}`}
                src={chapter.photo_min}
              />}
            {chapter.miniature &&
              <IonImg
                alt={`Portada del episodio ${chapter.title}`}
                src={chapter.miniature}
              />}
          </Link>
        </figure>
        <figcaption className='controls'>
          <ContentButton content={chapter} />
        </figcaption>
      </div>
    )
  } else {
    return (
      <p>Capítulo no válido</p>
    )
  }
}

export default PlayableChapterSmallCard
